import React, { useState } from "react";
import { Currency } from "../../../interfaces/Currency";

interface FxFiltersProps {
  initial?: {
    q?: string;
    base?: Currency;
    quote?: Currency;
    minRate?: number;
    maxRate?: number;
  };
  onApply: (filters: {
    q?: string;
    base?: Currency;
    quote?: Currency;
    minRate?: number;
    maxRate?: number;
  }) => void;
}

export default function FxFilters({ initial, onApply }: FxFiltersProps) {
  const [filters, setFilters] = useState({
    q: initial?.q || "",
    base: initial?.base || "",
    quote: initial?.quote || "",
    minRate: initial?.minRate || "",
    maxRate: initial?.maxRate || "",
  });

  const handleInputChange = (field: string, value: string | number) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const cleanFilters = {
      q: filters.q.trim() || undefined,
      base: (filters.base.trim() as Currency) || undefined,
      quote: (filters.quote.trim() as Currency) || undefined,
      minRate: filters.minRate ? Number(filters.minRate) : undefined,
      maxRate: filters.maxRate ? Number(filters.maxRate) : undefined,
    };
    onApply(cleanFilters);
  };

  const handleReset = () => {
    setFilters({
      q: "",
      base: "",
      quote: "",
      minRate: "",
      maxRate: "",
    });
    onApply({});
  };

  const currencies: Currency[] = ["USD", "EUR", "GBP"];

  return (
    <div className="card mb-3" style={{ width: "100%", maxWidth: "100%" }}>
      <div className="card-body">
        <form onSubmit={handleSubmit}>
          <div className="row g-3" style={{ minWidth: 0 }}>
            <div className="col-md-3">
              <label htmlFor="search" className="form-label">
                Search
              </label>
              <input
                type="text"
                className="form-control"
                id="search"
                placeholder="Search rates..."
                value={filters.q}
                onChange={(e) => handleInputChange("q", e.target.value)}
              />
            </div>

            <div className="col-md-2">
              <label htmlFor="base" className="form-label">
                Base Currency
              </label>
              <select
                className="form-select"
                id="base"
                value={filters.base}
                onChange={(e) => handleInputChange("base", e.target.value)}
              >
                <option value="">All</option>
                {currencies.map((currency) => (
                  <option key={currency} value={currency}>
                    {currency}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-2">
              <label htmlFor="quote" className="form-label">
                Quote Currency
              </label>
              <select
                className="form-select"
                id="quote"
                value={filters.quote}
                onChange={(e) => handleInputChange("quote", e.target.value)}
              >
                <option value="">All</option>
                {currencies.map((currency) => (
                  <option key={currency} value={currency}>
                    {currency}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-2">
              <label htmlFor="minRate" className="form-label">
                Min Rate
              </label>
              <input
                type="number"
                className="form-control"
                id="minRate"
                placeholder="0.0000"
                step="0.0001"
                min="0"
                value={filters.minRate}
                onChange={(e) => handleInputChange("minRate", e.target.value)}
              />
            </div>

            <div className="col-md-3">
              <label htmlFor="maxRate" className="form-label">
                Max Rate
              </label>
              <input
                type="number"
                className="form-control"
                id="maxRate"
                placeholder="10.0000"
                step="0.0001"
                min="0"
                value={filters.maxRate}
                onChange={(e) => handleInputChange("maxRate", e.target.value)}
              />
            </div>
          </div>

          {/* Buttons row */}
          <div className="row mt-3">
            <div className="col-12">
              <div className="d-flex gap-2">
                <button type="submit" className="btn-black">
                  Apply
                </button>
                <button type="button" className="btn-figma-1" onClick={handleReset}>
                  Reset
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
